import {
  Checkbox as MaterialCheckbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from "@material-ui/core";
import { omit } from "lodash";
import React from "react";

export type CheckboxProps = React.ComponentProps<typeof MaterialCheckbox> & {
  label?: React.ComponentProps<typeof FormControlLabel>["label"];
  error?: React.ComponentProps<typeof FormControl>["error"];
  helperText?: string;
};

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  (props, ref) =>
    props.label ? (
      <FormControl error={!!props.error} className={props.className}>
        <FormControlLabel
          control={
            <MaterialCheckbox
              inputRef={ref}
              {...omit(props, "helperText", "label", "error", "className")}
              color="primary"
            />
          }
          label={props.label}
        />
        {!!props.helperText ? (
          <FormHelperText>{props.helperText}</FormHelperText>
        ) : null}
      </FormControl>
    ) : (
      <MaterialCheckbox {...props} color="primary" />
    )
);
